export const TOGGLE_IS_LOADING = 'TOGGLE_IS_LOADING';
export const UPDATE_LOADING_MESSAGE = 'UPDATE_LOADING_MESSAGE';
